export default __webpack_public_path__ + "static/media/006-turkey.faf041ff.svg";